import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import ReportHeading from '@/Utils/report-head-awareness'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat } from '@/Utils/fliter'
function getBase64ImageFromURL (url) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')
    img.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      resolve(dataURL)
    }
    img.onerror = error => {
      reject(error)
    }
    img.src = url
  })
}
const exportPdfDetails = async (reportTitle, data, vm, awarenessEventServiceBaseUrl, baseUrl, uri, orgId) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = [
          {
            columns: reportHeadData.reportHeadColumn
          },
          { text: reportHeadData.orgName, style: 'orgName', alignment: 'center' },
          { text: reportHeadData.address, style: 'address', alignment: 'center' }
        ]
        pdfContent.push({ text: reportTitle, style: 'header2', alignment: 'center' })
        try {
          if (data.photo) {
            pdfContent.push(
              { image: await getBase64ImageFromURL(awarenessEventServiceBaseUrl + 'download-attachment?file=app/public' + data.photo), width: 100, height: 100, style: 'search', rowSpan: 5, absolutePosition: { x: 410, y: 170 } }
            )
          } else {
            pdfContent.push(
              { image: await getBase64ImageFromURL(awarenessEventServiceBaseUrl + 'download-attachment?file=app/public/no-image.jpg'), width: 100, height: 100, style: 'search', rowSpan: 5, absolutePosition: { x: 410, y: 170 } }
            )
          }
        } catch (e) {
          pdfContent.push(
            { image: await getBase64ImageFromURL(awarenessEventServiceBaseUrl + 'download-attachment?file=app/public/no-image.jpg'), width: 100, height: 100, style: 'search', rowSpan: 5, absolutePosition: { x: 410, y: 170 } }
          )
        }

        const allRowsHead = [
          [
          { text: vm.$t('info_manage.patient_id'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: vm.$n(data.application_id, { useGrouping: false }), alignment: 'left', style: 'search' },
          { text: '', alignment: 'right', style: 'search' },
          { text: '', style: 'search', alignment: 'center' },
          { text: '', alignment: 'left', style: 'search' }
          ]
        ]
      allRowsHead.push([
        { text: vm.$t('globalTrans.name'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.name : data.name_bn, alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('globalTrans.father_name'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.father_name : data.father_name_bn, alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('globalTrans.mother_name'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.mother_name : data.mother_name_bn, alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('externalUser.mobile_no'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.$n('0') + vm.$n(data.mobile, { useGrouping: false }), alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('externalUser.disability_types'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.getDisabilityTypeNameList(data.disability_types), alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('globalTrans.gender'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.gender : data.gender_bn, alignment: 'left', style: 'search' },
        { text: '', alignment: 'right', style: 'search' },
        { text: '', style: 'search', alignment: 'center' },
        { text: '', alignment: 'left', style: 'search' }
      ])
      // allRowsHead.push([
      //   { text: vm.$t('externalUser.service_type'), alignment: 'right', style: 'search' },
      //   { text: ':', style: 'search', alignment: 'center' },
      //   { text: i18n.locale === 'en' ? data.service_name : data.service_name_bn, alignment: 'left', style: 'search' },
      //   { text: '', alignment: 'right', style: 'search' },
      //   { text: '', style: 'search', alignment: 'center' },
      //   { text: '', alignment: 'left', style: 'search' }
      // ])
      if (data.marital_status === 1) {
        allRowsHead.push([
          { text: vm.$t('info_manage.spouse_name'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.spouse_name : data.spouse_name_bn, alignment: 'left', style: 'search' },
          { text: '', alignment: 'right', style: 'search' },
          { text: '', style: 'search', alignment: 'center' },
          { text: '', alignment: 'left', style: 'search' }
        ])
      }
      allRowsHead.push([
        { text: vm.$t('event_manage.year'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.$n(data.registration_year, { useGrouping: false }), alignment: 'left', style: 'search' },
        { text: vm.$t('consultancy_therapy_center.center_name'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.current_center_name : data.current_center_name_bn, alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('event_manage.registration_date'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: dateFormat(data.registration_date), alignment: 'left', style: 'search' },
        { text: vm.$t('externalUser.dss_id'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.$n(data.dss_id, { useGrouping: false }), alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('externalUser.birth_id'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.$n(data.birth_id, { useGrouping: false }), alignment: 'left', style: 'search' },
        { text: vm.$t('externalUser.marital_status'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.mat_status : data.mat_status_bn, alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('globalTrans.date_of_birth'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: dateFormat(data.birth_date), alignment: 'left', style: 'search' },
        { text: vm.$t('event_manage.month'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: i18n.locale === 'en' ? data.month : data.month_bn, alignment: 'left', style: 'search' }
      ])
      allRowsHead.push([
        { text: vm.$t('event_manage.nid_no'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.$n(data.nid, { useGrouping: false }), alignment: 'left', style: 'search' },
        { text: vm.$t('globalTrans.status'), alignment: 'right', style: 'search' },
        { text: ':', style: 'search', alignment: 'center' },
        { text: vm.getStatus(data.status), alignment: 'left', style: 'search' }
      ])
      pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['24%', '2%', '24%', '24%', '2%', '24%'],
            body: allRowsHead
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push([
          { text: vm.$t('info_manage.present_address') + '                                                         ' + vm.$t('info_manage.permanent_address'), style: 'design', alignment: 'center' }
        ])
        const allRowsHead1 = [
          [
          { text: vm.$t('org_pro_division.division'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.division_name : data.division_name_bn, alignment: 'left', style: 'search' },
          { text: vm.$t('org_pro_division.division'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.division_name : data.division_name_bn, alignment: 'left', style: 'search' }
        ]
      ]
      if (data.pr_district_id && data.pm_district_id) {
        allRowsHead1.push([
          { text: vm.$t('org_pro_district.district'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.district_name : data.district_name_bn, alignment: 'left', style: 'search' },
          { text: vm.$t('org_pro_district.district'), alignment: 'right', style: 'search' },
          { text: ':', style: 'search', alignment: 'center' },
          { text: i18n.locale === 'en' ? data.district_name : data.district_name_bn, alignment: 'left', style: 'search' }
        ])
      }
      if (data.pr_upazila_id && data.pm_upazila_id) {
        allRowsHead1.push([
            { text: vm.$t('org_pro_upazilla.upazilla'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.upazilla_name : data.upazilla_name_bn, alignment: 'left', style: 'search' },
            { text: vm.$t('org_pro_upazilla.upazilla'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.upazilla_name : data.upazilla_name_bn, alignment: 'left', style: 'search' }
          ])
      }
      if (data.pr_union_id && data.pm_union_id) {
        allRowsHead1.push([
            { text: vm.$t('org_pro_union.union'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.union_name : data.union_name_bn, alignment: 'left', style: 'search' },
            { text: vm.$t('org_pro_union.union'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.union_name : data.union_name_bn, alignment: 'left', style: 'search' }
          ])
      }
      if (data.pr_city_corporation_id && data.pm_city_corporation_id) {
        allRowsHead1.push([
            { text: vm.$t('org_pro.city_corporation'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.cityCor_name : data.cityCor_name_bn, alignment: 'left', style: 'search' },
            { text: vm.$t('org_pro.city_corporation'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.pm_cityCor_name : data.pm_cityCor_name_bn, alignment: 'left', style: 'search' }
          ])
      }
      if (data.pr_ward_id && data.pm_ward_id) {
        allRowsHead1.push([
            { text: vm.$t('org_pro.ward'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.ward_name : data.ward_name_bn, alignment: 'left', style: 'search' },
            { text: vm.$t('org_pro.ward'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.ward_name : data.ward_name_bn, alignment: 'left', style: 'search' }
          ])
      }
      if (data.pr_paurasabha_id && data.pm_paurasabha_id) {
        allRowsHead1.push([
            { text: vm.$t('org_pro.pauroshoba'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.pauroshoba_name : data.pauroshoba_name_bn, alignment: 'left', style: 'search' },
            { text: vm.$t('org_pro.pauroshoba'), alignment: 'right', style: 'search' },
            { text: ':', style: 'search', alignment: 'center' },
            { text: i18n.locale === 'en' ? data.pauroshoba_name : data.pauroshoba_name_bn, alignment: 'left', style: 'search' }
          ])
        }
      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['24%', '2%', '24%', '24%', '2%', '24%'],
          body: allRowsHead1
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social Welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portable',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          th: {
            fontSize: (i18n.locale === 'bn') ? 10 : 9,
            margin: [3, 3, 3, 3]
          },
            th1: {
                fontSize: 9
            },
            td: {
                fontSize: (i18n.locale === 'bn') ? 10 : 9,
                margin: [3, 3, 3, 3]
            },
            td1: {
              fontSize: (i18n.locale === 'bn') ? 8 : 7,
              margin: [3, 3, 3, 3]
            },
            design: {
              margin: [53, 3, 50, 3]
            },
            search: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [3, 3, 3, 3]
            },
            searchtwo: {
              fontSize: (i18n.locale === 'bn') ? 10 : 8,
              margin: [63, 13, 13, 13]
            },
            fertilizer: {
              margin: [5, 0, 0, 5]
            },
            header: {
              fontSize: 12,
              margin: [0, 0, 0, 4]
            },
            header2: {
              fontSize: 14,
              margin: [0, 10, 0, 20]
            },
            headerPort1: {
              fontSize: 10,
              margin: [0, 20, 0, 5]
            },
            headerPort: {
              fontSize: 10,
              margin: [0, 4, 0, 15]
            },
            krishi: {
              margin: [0, -5, 0, 15],
              alignment: 'center'
            },
            header3: {
              fontSize: 9,
              margin: [0, 0, 0, 0]
            },
            govt_info: {
              margin: [0, 3, 0, 0],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
              fontSize: 9,
              margin: [10, 0, 0, 0]
            },
            tdtwo: {
              fontSize: 10,
              margin: [0, 0, 0, 0]
            },
            td2: {
                border: 0,
                fontSize: 13,
                alignment: 'center'
              },
            AddressTable: {
              margin: [0, 0, 250, 0]
            },
            tableHeader: {
              fontSize: 11
            },
            noborder: {
               border: 0
            },
            left_logo: {
              borderRadius: 50
            },
            mainName: {
              margin: [8, 0, 0, 20]
            },
            tableExample: {
              fontSize: 11,
              margin: [0, 10, 10, 10]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
